<template>
  <Card>
    <el-row :gutter="20" class="action_card">
      <el-col :lg="4" :xs="6" class="action_card_image">
        <div class="crop"><img src="@/assets/images/no_account.png" alt /></div>
      </el-col>
      <el-col :lg="15" :xs="14">
        <div class="pending_content" :class="!isShowPoaNotice ? 'pending_content_center' : ''">
          <span>
            {{ title }}
            <el-popover popper-class="pop_content" placement="bottom" width="200" trigger="click" :content="content">
              <i slot="reference" class="el-icon-info info_icon_mobile"></i>
            </el-popover>
          </span>

          <p class="whitespace-pre-line">
            {{ content }}
          </p>
        </div>
      </el-col>
      <el-col :lg="5" :xs="4" class="action_card_button">
        <div class="form_button right_content">
          <el-button class="blue_button" @click="confirm" data-testid="confirm">{{ buttonLabel }}</el-button>
        </div>
        <i class="el-icon-arrow-right right_content_mobile" @click="confirm" data-testid="confirm"></i>
      </el-col>
    </el-row>
  </Card>
</template>

<script>
import { mapGetters } from 'vuex';
import Card from '@/components/Card';
import { RegisterRoutePath } from '@/router/registerRoutes';

export default {
  name: 'PendingAction',
  components: { Card },
  props: { isShowPoaNotice: { type: Boolean, default: false } },
  computed: {
    title() {
      return this.isShowPoaNotice
        ? this.$t('identityProof.home.poaRequired.header')
        : this.$t('identityProof.home.header');
    },
    content() {
      return this.isShowPoaNotice
        ? this.$t(`identityProof.home.poaRequired.content`)
        : this.$t('identityProof.home.content', {
            name: this.$store.state.common.individualUserName
          });
    },
    buttonLabel() {
      return this.isShowPoaNotice ? this.$t('common.button.verifyNow') : this.$t('common.button.identityProof');
    },
    ...mapGetters('common', ['idPass', 'isPoaEditable'])
  },
  methods: {
    confirm() {
      this.$router.push(RegisterRoutePath.register);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/home/pendingAction.scss';
</style>
